import { Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { getType } from 'typesafe-actions';
import { GroupToken } from '../../../../../../common/constants/strings';
import { rootSelector } from '../../../../../../common/selectors/selectors';
import {
  CenteredText,
  TopMarginGrid,
} from '../../../../../../common/styles/styles';
import {
  groupChangePasswordActions,
  groupVisitPasswordActions,
} from '../../../../groupVisits.actions';
import { GroupVisitResetPasswordDto } from '../../../../groupVisits.dtos';
import GroupVisitHeader from '../../headers/groupVisitHeader';
import GroupVisitChangePassword from './groupVisitChangePassword';
import GroupVisitLoginForm from './groupVisitLoginForm';

interface DetailParams {
  id: string;
}

const GroupVisitLogin: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
}) => {
  const dispatch = useDispatch();
  let isAuthenticated = sessionStorage.getItem(GroupToken) ?? false;
  const auth = rootSelector((state) => state.auth.isAuthenticated);
  const passwordResetRequired = rootSelector(
    (state) => state.groupVisits.passwordResetRequired
  );

  useEffect(() => {
    dispatch({
      type: getType(groupVisitPasswordActions.request),
      payload: match.params.id,
    });
  }, []);

  useEffect(() => {
    let isCancelled = false;

    if (!isCancelled) {
      isAuthenticated = auth;
    }

    return () => {
      isCancelled = true;
    };
  }, [isAuthenticated]);

  const onResetPassword = (values: GroupVisitResetPasswordDto) => {
    values.groupVisitId = match.params.id;
    dispatch({
      type: getType(groupChangePasswordActions.request),
      payload: values,
    });
  };

  return (
    <>
      {isAuthenticated ? (
        <Redirect to={`/visit-summary/${match.params.id}`} />
      ) : null}
      <GroupVisitHeader title='Group Visit Summary Login' />
      <TopMarginGrid
        container
        alignItems='center'
        justify='center'
        direction='column'
      >
        <Grid item style={{ width: '50%' }}>
          <CenteredText>
            The Sloan and Longway team enjoyed hosting your group at our
            facilities. To access the group summary, please enter the password
            that was provided to the Group Teacher/Leader via email. If you are
            the group leader and did not receive your email, or you are having
            issues accessing your visit summary, please contact the Reservations
            team at:
          </CenteredText>
          <CenteredText>
            810-237-3409 |{' '}
            <span>
              <a href='mailto:Reservations@SloanLongway.org'>
                Reservations@SloanLongway.org
              </a>
            </span>{' '}
          </CenteredText>
        </Grid>
        <Grid item>
          {passwordResetRequired ? (
            <GroupVisitChangePassword onResetPassword={onResetPassword} />
          ) : (
            <GroupVisitLoginForm id={match.params.id} />
          )}
        </Grid>
      </TopMarginGrid>
    </>
  );
};

export default GroupVisitLogin;
